import { breakpointValues, Stripe, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { ActionsContainer, Container, Content } from './VendorResponseEditor.styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const VendorResponseEditorSkeleton = () => {
  const {
    value: screenSize
  } = useResponsiveBreakpoint();
  const isMobile = screenSize <= breakpointValues.xs;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isMobile ? /*#__PURE__*/_jsx(Stripe, {
      height: "227px",
      borderRadius: "3px",
      marginTop: "var(--ds-space-400, 32px)"
    }) : /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Stripe, {
        width: "36px",
        height: "36px",
        borderRadius: "3px"
      }), /*#__PURE__*/_jsxs(Content, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          height: "120px",
          borderRadius: "3px"
        }), /*#__PURE__*/_jsx(ActionsContainer, {
          children: /*#__PURE__*/_jsx(Stripe, {
            width: "80px",
            height: "32px",
            borderRadius: "3px"
          })
        })]
      })]
    })
  });
};